<app-z-dialog
  [title]="('COMMON.DISAPPROVE' | translate) + ' - ' + name"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <z-input
    [label]="'COMMON.OBSERVATIONS' | translate"
    [formControlRef]="observacoes"
  ></z-input>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    [label]="'COMMON.SAVE' | translate"
    icon="check"
    color="primary"
    [mat-dialog-close]="true"
    (clicked)="send()"
    cdkFocusInitial
  ></z-button>
</ng-template>
